// gcf_store.js
import axios from "axios";

const state = {
    gcfResponse: null,
    loading: false,
    error: null
};

const getters = {
    getGCFResponse: state => state.gcfResponse,
    isLoading: state => state.loading,
    getError: state => state.error
};

const mutations = {
    SET_GCF_RESPONSE(state, response) {
        state.gcfResponse = response;
    },
    SET_LOADING(state, status) {
        state.loading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    getAxios: async ({commit}, payload) => {
        return axios.create({
            baseURL: process.env.VUE_APP_NEW_API_URL,
            headers: {
                Accept: 'application/json',
                'X-Lang-Header': payload.lang,
                Authorization: payload.auth,
            },
        });
    },

    prepareYoungTreeAsync: async ({dispatch, commit}, {payload, headers}) => {
        const myAxios = await dispatch('getAxios', headers);
        return await myAxios.post('/api/services/payment/pending-tree', payload)
            .then(({data}) => {
                return {
                    isSuccess: true,
                    data: data.data,
                }
            })
            .catch(e => {
                return {
                    isSuccess: false,
                    exception: e.response && e.response.data ? e.response.data : e
                }
            });
    },

    // Метод для инициализации GCF платежа
    initGCFAsync: async ({commit}, {payload, headers}) => {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);

        try {
            // Создаем инвойс для GCF платежа
            const response = await axios.post(
                `${process.env.VUE_APP_NEW_API_URL}/payment/prepare-gcf`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': headers.auth,
                        'X-Lang-Header': headers.lang
                    }
                }
            );

            commit('SET_GCF_RESPONSE', response.data);
            commit('SET_LOADING', false);

            return {
                isSuccess: true,
                data: response.data,
            };
        } catch (error) {
            console.error('GCF API error:', error);
            commit('SET_ERROR', error.message || 'Error connecting to payment service');
            commit('SET_LOADING', false);

            const responseData = error.response && error.response.data ? error.response.data : null;

            return {
                isSuccess: false,
                exception: {
                    textError: error.message || 'Failed to connect to payment service',
                    data: responseData
                }
            };
        }
    },

    // Метод для верификации GCF платежа
    verifyGCFPaymentAsync: async ({commit}, {payload, headers}) => {
        commit('SET_LOADING', true);

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_NEW_API_URL}/payment/verify-gcf`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': headers.auth,
                        'X-Lang-Header': headers.lang
                    }
                }
            );

            commit('SET_LOADING', false);

            return {
                isSuccess: true,
                data: response.data
            };
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);

            const responseData = error.response && error.response.data ? error.response.data : null;

            return {
                isSuccess: false,
                exception: {
                    textError: error.message,
                    data: responseData
                }
            };
        }
    },

    // Webhook для уведомления о статусе платежа
    notifyWebhookAsync: async ({commit}, {payload, headers}) => {
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_NEW_API_URL}/payment/webhook`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': headers.auth,
                        'X-Lang-Header': headers.lang
                    }
                }
            );

            return {
                isSuccess: true,
                data: response.data
            };
        } catch (error) {
            console.error('Error notifying webhook:', error);

            const responseData = error.response && error.response.data ? error.response.data : null;

            return {
                isSuccess: false,
                exception: {
                    textError: error.message,
                    data: responseData
                }
            };
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};